let peggyParser = (function () {
  function peg$SyntaxError(message, expected, found, location) {
    var self = Error.call(this, message);
    return (
      Object.setPrototypeOf && Object.setPrototypeOf(self, peg$SyntaxError.prototype),
      (self.expected = expected),
      (self.found = found),
      (self.location = location),
      (self.name = "SyntaxError"),
      self
    );
  }
  function peg$padEnd(str, targetLength, padString) {
    return ((padString = padString || " "), str.length > targetLength)
      ? str
      : ((targetLength -= str.length), str + (padString += padString.repeat(targetLength)).slice(0, targetLength));
  }
  return (
    !(function (child, parent) {
      function C() {
        this.constructor = child;
      }
      (C.prototype = parent.prototype), (child.prototype = new C());
    })(peg$SyntaxError, Error),
    (peg$SyntaxError.prototype.format = function (sources) {
      var str = "Error: " + this.message;
      if (this.location) {
        var k,
          src = null;
        for (k = 0; k < sources.length; k++)
          if (sources[k].source === this.location.source) {
            src = sources[k].text.split(/\r\n|\n|\r/g);
            break;
          }
        var s = this.location.start,
          offset_s =
            this.location.source && "function" == typeof this.location.source.offset
              ? this.location.source.offset(s)
              : s,
          loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
        if (src) {
          var e = this.location.end,
            filler = peg$padEnd("", offset_s.line.toString().length, " "),
            line = src[s.line - 1],
            hatLen = (s.line === e.line ? e.column : line.length + 1) - s.column || 1;
          str +=
            "\n --> " +
            loc +
            "\n" +
            filler +
            " |\n" +
            offset_s.line +
            " | " +
            line +
            "\n" +
            filler +
            " | " +
            peg$padEnd("", s.column - 1, " ") +
            peg$padEnd("", hatLen, "^");
        } else str += "\n at " + loc;
      }
      return str;
    }),
    (peg$SyntaxError.buildMessage = function (expected, found) {
      var DESCRIBE_EXPECTATION_FNS = {
        literal: function (expectation) {
          return '"' + literalEscape(expectation.text) + '"';
        },
        class: function (expectation) {
          var escapedParts = expectation.parts.map(function (part) {
            return Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part);
          });
          return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]";
        },
        any: function () {
          return "any character";
        },
        end: function () {
          return "end of input";
        },
        other: function (expectation) {
          return expectation.description;
        },
      };
      function hex(ch) {
        return ch.charCodeAt(0).toString(16).toUpperCase();
      }
      function literalEscape(s) {
        return s
          .replace(/\\/g, "\\\\")
          .replace(/"/g, '\\"')
          .replace(/\0/g, "\\0")
          .replace(/\t/g, "\\t")
          .replace(/\n/g, "\\n")
          .replace(/\r/g, "\\r")
          .replace(/[\x00-\x0F]/g, function (ch) {
            return "\\x0" + hex(ch);
          })
          .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
            return "\\x" + hex(ch);
          });
      }
      function classEscape(s) {
        return s
          .replace(/\\/g, "\\\\")
          .replace(/\]/g, "\\]")
          .replace(/\^/g, "\\^")
          .replace(/-/g, "\\-")
          .replace(/\0/g, "\\0")
          .replace(/\t/g, "\\t")
          .replace(/\n/g, "\\n")
          .replace(/\r/g, "\\r")
          .replace(/[\x00-\x0F]/g, function (ch) {
            return "\\x0" + hex(ch);
          })
          .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
            return "\\x" + hex(ch);
          });
      }
      function describeExpectation(expectation) {
        return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
      }
      return (
        "Expected " +
        (function (expected) {
          var i,
            j,
            descriptions = expected.map(describeExpectation);
          if ((descriptions.sort(), descriptions.length > 0)) {
            for (i = 1, j = 1; i < descriptions.length; i++)
              descriptions[i - 1] !== descriptions[i] && ((descriptions[j] = descriptions[i]), j++);
            descriptions.length = j;
          }
          switch (descriptions.length) {
            case 1:
              return descriptions[0];
            case 2:
              return descriptions[0] + " or " + descriptions[1];
            default:
              return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
          }
        })(expected) +
        " but " +
        (found ? '"' + literalEscape(found) + '"' : "end of input") +
        " found."
      );
    }),
    {
      StartRules: ["Expression"],
      SyntaxError: peg$SyntaxError,
      parse: function (input, options) {
        var startPos,
          endPos,
          offset,
          startPosDetails,
          endPosDetails,
          res,
          expected,
          found,
          peg$result,
          peg$FAILED = {},
          peg$source = (options = void 0 !== options ? options : {}).grammarSource,
          peg$startRuleFunctions = {
            Expression: peg$parseExpression,
          },
          peg$startRuleFunction = peg$parseExpression,
          peg$r0 = /^[0-9]/,
          peg$r1 = /^[,.]/,
          peg$r2 = /^[kKmMbBtT%]/,
          peg$r3 = /^[ ]/,
          peg$e0 = peg$literalExpectation("..", !1),
          peg$e1 = peg$otherExpectation("float"),
          peg$e2 = peg$classExpectation([["0", "9"]], !1, !1),
          peg$e3 = peg$classExpectation([",", "."], !1, !1),
          peg$e4 = peg$otherExpectation("integer"),
          peg$e5 = peg$literalExpectation("-", !1),
          peg$e6 = peg$classExpectation(["k", "K", "m", "M", "b", "B", "t", "T", "%"], !1, !1),
          peg$e7 = peg$literalExpectation(">", !1),
          peg$e8 = peg$literalExpectation("=", !1),
          peg$e9 = peg$literalExpectation("<", !1),
          peg$e10 = peg$literalExpectation(">=", !1),
          peg$e11 = peg$literalExpectation("<=", !1),
          peg$e12 = peg$literalExpectation("!=", !1),
          peg$e13 = peg$literalExpectation("<>", !1),
          peg$e14 = peg$classExpectation([" "], !1, !1),
          peg$currPos = 0 | options.peg$currPos,
          peg$posDetailsCache = [
            {
              line: 1,
              column: 1,
            },
          ],
          peg$maxFailPos = peg$currPos,
          peg$maxFailExpected = options.peg$maxFailExpected || [],
          peg$silentFails = 0 | options.peg$silentFails;
        if (options.startRule) {
          if (!(options.startRule in peg$startRuleFunctions))
            throw Error("Can't start parsing from rule \"" + options.startRule + '".');
          peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function peg$literalExpectation(text, ignoreCase) {
          return {
            type: "literal",
            text: text,
            ignoreCase: ignoreCase,
          };
        }
        function peg$classExpectation(parts, inverted, ignoreCase) {
          return {
            type: "class",
            parts: parts,
            inverted: inverted,
            ignoreCase: ignoreCase,
          };
        }
        function peg$otherExpectation(description) {
          return {
            type: "other",
            description: description,
          };
        }
        function peg$computePosDetails(pos) {
          var p,
            details = peg$posDetailsCache[pos];
          if (details) return details;
          if (pos >= peg$posDetailsCache.length) p = peg$posDetailsCache.length - 1;
          else for (p = pos; !peg$posDetailsCache[--p]; );
          for (
            details = {
              line: (details = peg$posDetailsCache[p]).line,
              column: details.column,
            };
            p < pos;

          )
            10 === input.charCodeAt(p) ? (details.line++, (details.column = 1)) : details.column++, p++;
          return (peg$posDetailsCache[pos] = details), details;
        }
        function peg$fail(expected) {
          !(peg$currPos < peg$maxFailPos) &&
            (peg$currPos > peg$maxFailPos && ((peg$maxFailPos = peg$currPos), (peg$maxFailExpected = [])),
            peg$maxFailExpected.push(expected));
        }
        function peg$parseExpression() {
          var s0, s01, s1;
          return (
            (s0 = (function () {
              var s0, s1, s3, s01, s02, s11, s03, s12, s2, s31, s04, s13, s21, s32, s05, s14, s06, s15, s07, s16;
              if (
                ((s0 = peg$currPos),
                "!=" === input.substr(peg$currPos, 2)
                  ? ((s02 = "!="), (peg$currPos += 2))
                  : ((s02 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e12)),
                s02 === peg$FAILED &&
                  ((s02 = peg$currPos),
                  "<>" === input.substr(peg$currPos, 2)
                    ? ((s11 = "<>"), (peg$currPos += 2))
                    : ((s11 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e13)),
                  s11 !== peg$FAILED && (s11 = "!="),
                  (s02 = s11)),
                (s01 = s02) === peg$FAILED &&
                  ((s03 = peg$currPos),
                  62 === input.charCodeAt(peg$currPos)
                    ? ((s12 = ">"), peg$currPos++)
                    : ((s12 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e7)),
                  s12 !== peg$FAILED
                    ? ((s2 = peg$currPos),
                      peg$silentFails++,
                      61 === input.charCodeAt(peg$currPos)
                        ? ((s31 = "="), peg$currPos++)
                        : ((s31 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e8)),
                      peg$silentFails--,
                      s31 === peg$FAILED ? (s2 = void 0) : ((peg$currPos = s2), (s2 = peg$FAILED)),
                      s2 !== peg$FAILED ? (s03 = ">") : ((peg$currPos = s03), (s03 = peg$FAILED)))
                    : ((peg$currPos = s03), (s03 = peg$FAILED)),
                  (s01 = s03) === peg$FAILED &&
                    ((s04 = peg$currPos),
                    60 === input.charCodeAt(peg$currPos)
                      ? ((s13 = "<"), peg$currPos++)
                      : ((s13 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e9)),
                    s13 !== peg$FAILED
                      ? ((s21 = peg$currPos),
                        peg$silentFails++,
                        61 === input.charCodeAt(peg$currPos)
                          ? ((s32 = "="), peg$currPos++)
                          : ((s32 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e8)),
                        peg$silentFails--,
                        s32 === peg$FAILED ? (s21 = void 0) : ((peg$currPos = s21), (s21 = peg$FAILED)),
                        s21 !== peg$FAILED ? (s04 = "<") : ((peg$currPos = s04), (s04 = peg$FAILED)))
                      : ((peg$currPos = s04), (s04 = peg$FAILED)),
                    (s01 = s04) === peg$FAILED &&
                      (">=" === input.substr(peg$currPos, 2)
                        ? ((s14 = ">="), (peg$currPos += 2))
                        : ((s14 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e10)),
                      s14 !== peg$FAILED && (s14 = ">="),
                      (s01 = s14) === peg$FAILED &&
                        ("<=" === input.substr(peg$currPos, 2)
                          ? ((s15 = "<="), (peg$currPos += 2))
                          : ((s15 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e11)),
                        s15 !== peg$FAILED && (s15 = "<="),
                        (s01 = s15) === peg$FAILED)))) &&
                  (61 === input.charCodeAt(peg$currPos)
                    ? ((s16 = "="), peg$currPos++)
                    : ((s16 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e8)),
                  s16 !== peg$FAILED && (s16 = "="),
                  (s01 = s16)),
                (s1 = s01) !== peg$FAILED)
              )
                ((function () {
                  var s0, s1;
                  for (
                    s0 = [],
                      s1 = input.charAt(peg$currPos),
                      peg$r3.test(s1) ? peg$currPos++ : ((s1 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e14));
                    s1 !== peg$FAILED;

                  )
                    s0.push(s1),
                      (s1 = input.charAt(peg$currPos)),
                      peg$r3.test(s1) ? peg$currPos++ : ((s1 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e14));
                })(),
                (s3 = peg$parseNum()) !== peg$FAILED)
                  ? (s0 = {
                      type: "COMPARISON",
                      operator: s1,
                      value: s3,
                    })
                  : ((peg$currPos = s0), (s0 = peg$FAILED));
              else (peg$currPos = s0), (s0 = peg$FAILED);
              return s0;
            })()) === peg$FAILED &&
              (s0 = (function () {
                var s0, s1, s2, s3, s4, s5;
                return (
                  ((s0 = peg$currPos),
                  (s1 = peg$parseNum()) !== peg$FAILED &&
                    (peg$parseREQUIRED_SPACING(),
                    ".." === input.substr(peg$currPos, 2)
                      ? ((s3 = ".."), (peg$currPos += 2))
                      : ((s3 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e0)),
                    s3 !== peg$FAILED && (peg$parseREQUIRED_SPACING(), (s5 = peg$parseNum()) !== peg$FAILED)))
                    ? (s0 = {
                        type: "RANGE",
                        range: s1 < 0 && s5 < 0 ? [s1, s5] : s1 > s5 ? [s5, s1] : [s1, s5],
                      })
                    : ((peg$currPos = s0), (s0 = peg$FAILED)),
                  s0
                );
              })()) === peg$FAILED &&
              ((s1 = peg$parseNum()) !== peg$FAILED &&
                (s1 = {
                  type: "VALUE",
                  value: s1,
                }),
              (s0 = s1)),
            s0
          );
        }
        function peg$parseNum() {
          var s0, s1, s2, s3, s01, s11, s02, s03, s12, suffix;
          if (
            ((s0 = peg$currPos),
            45 === input.charCodeAt(peg$currPos)
              ? ((s11 = "-"), peg$currPos++)
              : ((s11 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e5)),
            s11 !== peg$FAILED && (s11 = !0),
            (s1 = s11) === peg$FAILED && (s1 = null),
            (s02 = (function () {
              var s0, s1, s2, s3, s4, left, right;
              if (
                (peg$silentFails++,
                (s0 = peg$currPos),
                (s1 = []),
                (s2 = input.charAt(peg$currPos)),
                peg$r0.test(s2) ? peg$currPos++ : ((s2 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e2)),
                s2 !== peg$FAILED)
              )
                for (; s2 !== peg$FAILED; )
                  s1.push(s2),
                    (s2 = input.charAt(peg$currPos)),
                    peg$r0.test(s2) ? peg$currPos++ : ((s2 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e2));
              else s1 = peg$FAILED;
              if (s1 !== peg$FAILED) {
                if (
                  ((s2 = input.charAt(peg$currPos)),
                  peg$r1.test(s2) ? peg$currPos++ : ((s2 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e3)),
                  s2 !== peg$FAILED)
                ) {
                  if (
                    ((s3 = []),
                    (s4 = input.charAt(peg$currPos)),
                    peg$r0.test(s4) ? peg$currPos++ : ((s4 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e2)),
                    s4 !== peg$FAILED)
                  )
                    for (; s4 !== peg$FAILED; )
                      s3.push(s4),
                        (s4 = input.charAt(peg$currPos)),
                        peg$r0.test(s4)
                          ? peg$currPos++
                          : ((s4 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e2));
                  else s3 = peg$FAILED;
                  s3 !== peg$FAILED
                    ? ((left = s1), (right = s3), (s0 = parseFloat(left.join("") + "." + right.join(""))))
                    : ((peg$currPos = s0), (s0 = peg$FAILED));
                } else (peg$currPos = s0), (s0 = peg$FAILED);
              } else (peg$currPos = s0), (s0 = peg$FAILED);
              return (
                peg$silentFails--,
                s0 === peg$FAILED && ((s1 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e1)),
                s0
              );
            })()) === peg$FAILED &&
              (s02 = (function () {
                var s0, s1, s2;
                if (
                  (peg$silentFails++,
                  (s0 = peg$currPos),
                  (s1 = []),
                  (s2 = input.charAt(peg$currPos)),
                  peg$r0.test(s2) ? peg$currPos++ : ((s2 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e2)),
                  s2 !== peg$FAILED)
                )
                  for (; s2 !== peg$FAILED; )
                    s1.push(s2),
                      (s2 = input.charAt(peg$currPos)),
                      peg$r0.test(s2) ? peg$currPos++ : ((s2 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e2));
                else s1 = peg$FAILED;
                return (
                  s1 !== peg$FAILED && (s1 = parseInt(s1.join(""), 10)),
                  (s0 = s1),
                  peg$silentFails--,
                  s0 === peg$FAILED && ((s1 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e4)),
                  s0
                );
              })()),
            (s2 = s02) !== peg$FAILED)
          ) {
            (s12 = input.charAt(peg$currPos)),
              peg$r2.test(s12) ? peg$currPos++ : ((s12 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e6)),
              s12 === peg$FAILED && (s12 = null),
              (s3 = s12 = (suffix = s12) ? suffix[0] : null),
              (s0 = s1 ? -(s2 * multiplier(s3) * 1) : s2 * multiplier(s3));
          } else (peg$currPos = s0), (s0 = peg$FAILED);
          return s0;
        }
        function peg$parseREQUIRED_SPACING() {
          var s0, s1;
          if (
            ((s0 = []),
            (s1 = input.charAt(peg$currPos)),
            peg$r3.test(s1) ? peg$currPos++ : ((s1 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e14)),
            s1 !== peg$FAILED)
          )
            for (; s1 !== peg$FAILED; )
              s0.push(s1),
                (s1 = input.charAt(peg$currPos)),
                peg$r3.test(s1) ? peg$currPos++ : ((s1 = peg$FAILED), 0 === peg$silentFails && peg$fail(peg$e14));
          else s0 = peg$FAILED;
          return s0;
        }
        function multiplier(suffix) {
          return suffix
            ? "%" === (suffix = suffix.toLowerCase())
              ? 0.01
              : "k" === suffix
                ? 1000
                : "m" === suffix
                  ? 1000000
                  : "b" === suffix
                    ? 1000000000
                    : "t" === suffix
                      ? 1000000000000
                      : 1
            : 1;
        }
        if (((peg$result = peg$startRuleFunction()), options.peg$library))
          return {
            peg$result,
            peg$currPos,
            peg$FAILED,
            peg$maxFailExpected,
            peg$maxFailPos,
          };
        if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
        throw (
          (peg$result !== peg$FAILED &&
            peg$currPos < input.length &&
            peg$fail({
              type: "end",
            }),
          (expected = peg$maxFailExpected),
          (found = peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null),
          (startPos = peg$maxFailPos),
          (endPos = peg$maxFailPos < input.length ? peg$maxFailPos + 1 : peg$maxFailPos),
          (startPosDetails = peg$computePosDetails(startPos)),
          (endPosDetails = peg$computePosDetails(endPos)),
          (res = {
            source: peg$source,
            start: {
              offset: startPos,
              line: startPosDetails.line,
              column: startPosDetails.column,
            },
            end: {
              offset: endPos,
              line: endPosDetails.line,
              column: endPosDetails.column,
            },
          }),
          new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, res))
        );
      },
    }
  );
})();
peggyParser.SyntaxError.prototype.name = "PeggySyntaxError";
export const parse = peggyParser.parse;
export const PeggySyntaxError = peggyParser.SyntaxError;
